/**
 * Corp Events — one page for every scope.
 *
 * National corporate bookings, or one region's pipeline.
 *
 * The two bodies are the pages that used to live under `/admin/corp` and
 * `/r/:regionSlug/corp`. Neither has changed: at national scope this calls
 * the `/dashboards/admin/…` endpoint the admin page called, and at regional
 * scope the `/dashboards/regional/:slug/…` endpoint the regional page called,
 * so the numbers are the same numbers. What is gone is the second URL tree and
 * the second copy of the chrome around them.
 */
import { DashboardsPage } from '../DashboardsPage';
import { RegionalCorp } from '../regional/RegionalCorp';

import AdminCorp from './AdminCorp';
import { useDashboardScope } from './dashboard-scope';
import { DashboardScopeHeader } from './DashboardScopeHeader';
import { ScopedDashboardBody } from './ScopedDashboardBody';

export default function CorpEventsPage() {
  const scope = useDashboardScope();

  return (
    <DashboardsPage
      header={<DashboardScopeHeader title="Corp Events" basePath="/admin/corp" scope={scope} />}
    >
      <ScopedDashboardBody
        scope={scope}
        national={<AdminCorp />}
        regional={(regionSlug) => <RegionalCorp regionSlug={regionSlug} />}
      />
    </DashboardsPage>
  );
}
